import React from 'react';

import { CriteriaStep } from '../steps/CriteriaStep';
import { PickASegmentStep } from '../steps/PickASegmentStep';
import { ProgressStatusStep } from '../steps/ProgressStatusStep';
import { ReassuranceStep } from '../steps/ReassuranceStep';
import { ProductInformationStep } from '../steps/ProductInformationStep';
import { PickAGroupStep } from '../steps/PickAGroupStep';
import { PrivacyAgreementStep } from '../steps/PrivacyAgreementStep';
import { SignUpStep } from '../steps/SignUp/SignUpStep';
import { MeetingCommitmentStep } from '../steps/MeetingCommitmentStep';
import { PaymentStep } from '../steps/PaymentStep';
import { GoToAppStep } from '../steps/GoToAppStep/GoToAppStep';
import { FinishSignUpStep } from '../steps/FinishSignUpStep';
import { BaseStep } from './BaseStep';
import { ThinkingStep } from '../steps/ThinkingStep';
import { SpecialOfferStep } from '../steps/SpecialOfferStep';
import { MockPaymentStep } from '../steps/MockPaymentStep';
import { SignUpEmailStep } from '../steps/SignUp/SignUpEmailStep';
import { SignUpPhoneStep } from '../steps/SignUp/SignUpPhoneStep';
import { SinglePagePayment } from '../steps/SinglePagePayment';
import { SinglePagePickAGroup } from '../steps/SinglePagePickAGroup';
import { AgeStep } from '../steps/AgeStep';
import { RoomsSuggestions } from '../steps/RoomsSuggestions/RoomsSuggestions';
import { PickAProduct } from '../steps/PickAProduct/PickAProduct';
import { ContactDetailsStep } from '../steps/SignUp/ContactDetailsStep/ContactDetailsStep';
import { SignupWithPaymentStep } from '../steps/SignupWithPaymentStep/SignupWithPaymentStep';
import { CriteriaStepV2 } from '../steps/CriteriaV2/CriteriaV2Step';
import { ThanksForSharingLoaderStep } from '../steps/ThanksForSharingLoaderStep/ThanksForSharingLoaderStep';
import { SuggestedGuidesStep } from '../steps/SuggestedGuidesStep/SuggestedGuidesStep';
import { GoalsToAchieveStep } from '../steps/GoalsToAchieveStep/GoalsToAchieveStep';
import { PauseFullScreenStep } from '../steps/PauseFullScreenStep/PauseFullScreenStep';
import { EnterEmailStep } from '../steps/EnterEmailStep/EnterEmailStep';
import { InfoV1Step } from '../steps/InfoV1/InfoV1Step';
import { InfoV1Ver2Step } from '../steps/InfoV1Ver2/InfoV1Ver2Step';
import { InfoV2Step } from '../steps/InfoV2/InfoV2Step';
import { InfoV2Ver2Step } from '../steps/InfoV2Ver2/InfoV2Ver2Step';
import { CriteriaV3Step } from '../steps/CriteriaV3/CriteriaV3Step';
import { EnterEmailV2Step } from '../steps/EnterEmailV2/EnterEmailV2Step';
import { EnterEmailV3Step } from '../steps/EnterEmailV3/EnterEmailV3Step';
import { PickLabels } from '../steps/PickLabels/PickLabels';
import { PickAProgram } from '../steps/PickAProgram/PickAProgram';
import { CopingWithNarcissism } from '../steps/CopingWithNarcissim/CopingWithNarcissism';
import { LetsHealTogether } from '../steps/LetsHealTogether/LetsHealTogether';

export const ComponentFactory = (step: any, index: number) => {
  switch (step.stepType) {
    case 'criteria':
      return <CriteriaStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'pickASegment':
      return <PickASegmentStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'progressStatus':
      return <ProgressStatusStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'reassurance':
      return <ReassuranceStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'productInformation':
      return <ProductInformationStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'pickAGroup':
      return <PickAGroupStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'privacyAgreement':
      return <PrivacyAgreementStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'signUp':
      return <SignUpStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'contactDetails':
      return <ContactDetailsStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'signupWithPayment':
      return <SignupWithPaymentStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'meetingCommitment':
      return <MeetingCommitmentStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'payment':
      return <PaymentStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'goToAppStep':
      return <GoToAppStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'finishSignUp':
      return <FinishSignUpStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'noDocumentSteps':
      return <BaseStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'thinkingStep':
      return <ThinkingStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'specialOfferStep':
      return <SpecialOfferStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'mockPaymentStep':
      return <MockPaymentStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'signUpEmail':
      return <SignUpEmailStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'signUpPhone':
      return <SignUpPhoneStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'singlePagePayment':
      return <SinglePagePayment key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'singlePagePickAGroup':
      return <SinglePagePickAGroup key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'age':
      return <AgeStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'roomSuggestions':
      return <RoomsSuggestions key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'pickAProduct':
      return <PickAProduct key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'criteriaV2':
      return <CriteriaStepV2 key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'thanksForSharingLoader':
      return <ThanksForSharingLoaderStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'suggestedGuides':
      return <SuggestedGuidesStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'goalsToAchieve':
      return <GoalsToAchieveStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'pauseFullScreen':
      return <PauseFullScreenStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'enterEmail':
      return <EnterEmailStep key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'criteriaV3':
      return <CriteriaV3Step key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'pickLabels':
      return <PickLabels key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'infoV1':
      return <InfoV1Step key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'infoV1Ver2':
      return <InfoV1Ver2Step key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'infoV2':
      return <InfoV2Step key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'infoV2Ver2':
      return <InfoV2Ver2Step key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'enterEmailV2':
      return <EnterEmailV2Step key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'enterEmailV3':
      return <EnterEmailV3Step key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'pickAProgram':
      return <PickAProgram key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'copingWithNarcissism':
      return <CopingWithNarcissism key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    case 'letsHealTogether':
      return <LetsHealTogether key={step.stepName} {...step} stepIndex={index} {...step.metaData} />;
    default:
      return <div key="noSteps"></div>;
  }
};
